import { FC } from 'react';
// utils
import { download, getValidFilename } from '@newo/toolkit/file';
import { getBrowserGMTTimezone } from '@newo/toolkit/datetime';
import {
    useSuperAgentExportQuery,
    useSuperAgentExportV1Query
} from '@/services/init/init.queries.ts';
import { useProfileQuery } from '@/services/customer/profile/profile.queries.ts';
import { tzDatetime } from '@/modules/DateTime/utils';
import { isWindows } from '@/utils';
import ExportAgentButtonForm from '@/modules/SettingsDrawer/components/ExportAgentButton/ExportAgentButtonForm';
import type { TAgentData } from '@/modules/SettingsDrawer/components/ExportAgentButton/ExportAgentButtonForm/ExportAgentButtonForm';

type ExportAgentButtonProps = {
    isV2Enabled: boolean;
    projectId: string;
};
const ExportAgentButton: FC<ExportAgentButtonProps> = ({
    isV2Enabled,
    projectId
}) => {
    const { data: profile } = useProfileQuery();

    const handleSuccessExport = (result: string | null) => {
        if (result && profile) {
            const parts: [string, string | null, string, string] = [
                profile.idn,
                profile.organization_name,
                tzDatetime().toFormat('yyyy-LL-dd-HH-mm-ss-SSS'),
                getBrowserGMTTimezone()
            ];
            const filename = `superagent-${getValidFilename(parts)}.zip`;
            download(
                result,
                filename,
                isWindows()
                    ? 'application/x-zip-compressed'
                    : 'application/zip;'
            );
        }
    };

    const { mutate: exportSuperAgent, isPending: isV2Pending } =
        useSuperAgentExportQuery(handleSuccessExport);
    const { mutateAsync: exportSuperAgentV1, isPending: isV1Pending } =
        useSuperAgentExportV1Query(handleSuccessExport, projectId);

    const handleSubmit = async (data: TAgentData) => {
        const formData = new FormData();
        formData.append('export_akb', String(data.export_akb));
        formData.append(
            'export_customer_attributes',
            String(data.export_customer_attributes)
        );

        if (isV2Enabled) {
            exportSuperAgent(formData);
            return;
        }
        exportSuperAgentV1();
    };

    return (
        <ExportAgentButtonForm
            handleSubmit={handleSubmit}
            isLoading={isV2Pending || isV1Pending}
        />
    );
};

export default ExportAgentButton;
